import { type Component, onBeforeUnmount, onMounted, type Ref } from 'vue'

export default function useDetectOutsideClick(component: Ref<Component | null>, callback: () => void) {
  if (!component) return
  const listener = (event: Event) => {
    if (event.target !== component.value && event.composedPath().includes(component.value as never)) {
      return
    }
    if (typeof callback === 'function') {
      callback()
    }
  }
  onMounted(() => {
    window.addEventListener('click', listener)
  })
  onBeforeUnmount(() => {
    window.removeEventListener('click', listener)
  })

  return { listener }
}
